<template>
  <b-modal
    id="new-reward-modal"
    class="reward-modal"
    header-class="border-bottom pb-4"
    title="Add New Reward"
    size="lg"
    centered
    no-close-on-backdrop
    @show="initialize"
    @hide="onModalHide"
  >
    <b-form class="py-5">
      <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Availability
              <i class="ic-tooltip" id="availability-tooltip"></i>
              <b-popover
                target="availability-tooltip"
                triggers="hover"
                content="Availability"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-row v-if="planDetails.enable_estore_web == 1 || planDetails.enable_loyalty == 1">
              <b-col md="5" class="secondary-label">BAU</b-col>
              <b-col md="4">
                <switches
                  v-model="form.bau"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="form.is_punch_card || form.punch_card_visible"
                >
                </switches>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="planDetails.enable_privilege_card == 1">
              <b-col md="5" class="secondary-label"
                >Privilege Card Bundle</b-col
              >
              <b-col md="4">
                <switches
                  v-model="form.privilege_card"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="!enabledTopUps.includes('privilege_card') || form.is_punch_card || form.punch_card_visible"
                >
                </switches>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="planDetails.enable_membership_tiering == 1">
              <b-col md="5" class="secondary-label">Membership Tier</b-col>
              <b-col md="4">
                <switches
                  v-model="form.membership_tier"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="form.is_punch_card || form.punch_card_visible"
                >
                </switches>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5" class="secondary-label">Survey</b-col>
              <b-col md="4">
                <switches
                  v-model="form.survey"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="form.is_punch_card || form.punch_card_visible"
                >
                </switches>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="planDetails.enable_punch_card == 1">
              <b-col md="5" class="secondary-label">Punch Card</b-col>
              <b-col md="4">
                <switches
                  v-model="form.is_punch_card"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="!enabledTopUps.includes('punchcard')"
                >
                </switches>
              </b-col>
            </b-row>
            
            <b-form-invalid-feedback
              :force-show="!!displayError('availability')"
            >
              {{ displayError("availability") }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <hr class="mt-3 mb-5" />
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Visibility
              <i class="ic-tooltip" id="visibility-tooltip"></i>
              <b-popover
                target="visibility-tooltip"
                triggers="hover"
                content="Visibility"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-row v-if="planDetails.enable_customer_app_android == 1 || planDetails.enable_customer_app_ios == 1">
              <b-col md="5" class="secondary-label">Customer App</b-col>
              <b-col md="4">
                <switches
                  v-model="form.customer_app"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="form.punch_card_visible || form.is_punch_card"
                >
                </switches>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="planDetails.enable_estore_web || planDetails.enable_loyalty_web">
              <b-col md="5" class="secondary-label">Web</b-col>
              <b-col md="4">
                <switches
                  v-model="form.web"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="form.punch_card_visible || form.is_punch_card"
                >
                </switches>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="planDetails.enable_glife == 1">
              <b-col md="5" class="secondary-label">GLife</b-col>
              <b-col md="4">
                <switches
                  v-model="form.gcash"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="form.punch_card_visible || form.is_punch_card"
                >
                </switches>
              </b-col>
            </b-row>
            
            <b-row class="mt-2" v-if="planDetails.enable_punch_card == 1">
              <b-col md="5" class="secondary-label">Punch Card</b-col>
              <b-col md="4">
                <switches
                  v-model="form.punch_card_visible"
                  text-enabled="On"
                  text-disabled="Off"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: -17px"
                  :disabled="!form.is_punch_card"
                >
                </switches>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mt-3 mb-5" />
      <b-row no-gutters>
        <b-col md="4">
          <div class="primary-label">
            Reward Details
            <i class="ic-tooltip" id="reward-details-tooltip"></i>
            <b-popover
              target="reward-details-tooltip"
              triggers="hover"
              content="Reward Details"
            >
            </b-popover>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col md="10">
              <b-form-group
                label-for="reward-type"
                :invalid-feedback="displayError('type')"
                :state="validate('type')"
              >
                <div slot="label" class="secondary-label">Reward Type</div>
                <b-dropdown
                  variant="link"
                  class="dropdown-with-icon"
                  no-caret
                  menu-class="w-100"
                >
                  <template slot="button-content">
                    <b-container>
                      <b-row>
                        <b-col class="text-left pl-0"> {{ form.type }} </b-col>
                        <b-col class="text-right pr-0">
                          <img
                            src="@/assets/images/dropdown.svg"
                            alt="Dropdown"
                          />
                        </b-col>
                      </b-row>
                    </b-container>
                  </template>
                  <b-dropdown-item
                    v-for="(option, index) in rewardTypeOptions"
                    :key="index"
                    :value="option.value"
                    @click="form.type = option.value"
                    :class="option.value == 'Points' ? 'points-type' : ''"
                  >
                    <b-row>
                      <b-col>{{ option.value }}</b-col>
                      <b-col class="text-right">
                        <img
                          src="@/assets/images/icons/check-circle-orange.svg"
                          alt="Check"
                          v-if="form.type === option.value"
                        />
                      </b-col>
                    </b-row>
                  </b-dropdown-item>
                </b-dropdown>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="form.type === 'Voucher'">
            <b-row class="mt-3">
              <b-col md="10">
                <b-form-group>
                  <div slot="label" class="secondary-label">Voucher Type</div>
                  <b-form-radio-group
                    v-model="form.voucher_type"
                    :options="voucherTypeOptions"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="form.voucher_type === 'Value-Based'">
              <b-col md="8">
                <b-row>
                  <b-col
                    ><label for="voucher_discount_parameter" class="secondary-label"
                      >Value Discount</label
                    ></b-col
                  >
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-select
                      v-model="form.voucher_discount_parameter"
                      :options="voucherValueTypeOptions"
                    />
                  </b-col>
                  <b-col>
                    <b-form-group
                      :invalid-feedback="displayError('voucher_discount_value')"
                      :state="validate('voucher_discount_value')"
                    >
                      <b-input
                        type="number"
                        v-model="form.voucher_discount_value"
                        placeholder="0.00"
                        class="hide-input-number-spinner"
                      >
                      </b-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
          <template v-if="form.type === 'Instant Gratification'">
            <b-row class="mt-3">
              <b-col md="10">
                <b-form-group>
                  <div slot="label" class="secondary-label">
                    Instant Gratification Type
                  </div>
                  <b-form-radio-group
                    :checked="form.instant_grat_type"
                    :model="form.instant_grat_type = 'Rewards'"
                    :options="instantGratificationTypeOptions"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col md="10">
                <b-form-group>
                  <div slot="label" class="secondary-label">Issue Type</div>
                  <b-form-radio-group
                    v-model="form.issue_type"
                    :options="issueTypeOptions"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
          <b-row class="mt-3">
            <b-col md="10">
              <b-form-group
                label-for="reward-name"
                :invalid-feedback="displayError('name')"
                :state="validate('name')"
              >
                <div slot="label" class="secondary-label">Reward Name</div>
                <b-input
                  id="reward-name"
                  type="text"
                  v-model="form.name"
                  placeholder="Enter Reward Name"
                  :maxlength="maxRewardNameLength"
                  :state="validate('name')"
                >
                </b-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col>
              <b-form-group
                :invalid-feedback="displayError('image')"
                :state="validate('image')"
              >
                <div slot="label" class="secondary-label">Upload Image</div>
                <div
                  id="rewards-upload-image"
                  :class="{ 'border border-danger': !!displayError('image') }"
                  v-b-modal.upload-reward-image-modal
                >
                  <img v-if="form.image" :src="form.image" alt="upload" />
                  <div class="upload-icon rounded-circle border"></div>
                </div>
                <div class="tertiary-label mt-1">
                  Recommended size: 165 x 115 px
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            class="mt-3"
            v-if="
              form.type === 'Free' ||
              form.type === 'Points' ||
              form.type === 'Voucher' ||
              (form.type === 'Instant Gratification' &&
                form.instant_grat_type === 'Rewards'
                || form.instant_grat_type === 'Points')
            "
          >
            <b-col>
              <b-form-group
                label-for="reward-description"
                :invalid-feedback="displayError('description')"
                :state="validate('description')"
              >
                <div slot="label" class="secondary-label">
                  Reward Description
                </div>
                <b-form-textarea
                  id="reward-description"
                  rows="4"
                  v-model="form.description"
                  :maxlength="maxDescriptionLength"
                  placeholder="Enter Description"
                  :state="validate('description')"
                >
                </b-form-textarea>
                <div class="tertiary-label mt-1 ml-auto w-25 text-right">
                  ({{ descriptionCharCount }} / {{ maxDescriptionLength }})
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template
        v-if="
          form.type === 'Free' ||
          form.type === 'Points' ||
          form.type === 'Voucher' ||
          (form.type === 'Instant Gratification' &&
            form.instant_grat_type === 'Rewards'
            || form.instant_grat_type === 'Points')
        "
      >
        <hr class="my-5" />
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label mb-2">
              How To Redeem
              <i class="ic-tooltip" id="how-to-redeem-tooltip"></i>
              <b-popover
                target="how-to-redeem-tooltip"
                triggers="hover"
                content="How to Redeem"
              >
              </b-popover>
            </div>
            <switches
              v-model="form.show_redeem_instruction"
              text-enabled="On"
              text-disabled="Off"
              theme="custom"
              color="primary"
              type-bold="true"
              style="top: -17px"
            >
            </switches>
          </b-col>
          <b-col>
            <b-form-group
              label-for="how-to-redeem"
              :invalid-feedback="displayError('redeem_instruction')"
              :state="validate('redeem_instruction')"
            >
              <div slot="label" class="secondary-label">How to Redeem?</div>
              <b-form-textarea
                id="how-to-redeem"
                rows="4"
                v-model="form.redeem_instruction"
                :maxlength="maxHowToRedeemLength"
                placeholder="Enter Details"
                :state="validate('redeem_instruction')"
                :disabled="!form.show_redeem_instruction"
              >
              </b-form-textarea>
              <div class="tertiary-label mt-1 ml-auto w-25 text-right">
                ({{ howToRedeemCharCount }} / {{ maxHowToRedeemLength }})
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3" no-gutters>
          <b-col md="4">
            <div class="primary-label mb-2">
              Terms &#38; Conditions
              <i class="ic-tooltip" id="terms-and-conditions-tooltip"></i>
              <b-popover
                target="terms-and-conditions-tooltip"
                triggers="hover"
                content="Terms & Conditions"
              >
              </b-popover>
            </div>
            <switches
              v-model="form.show_display_instruction"
              text-enabled="On"
              text-disabled="Off"
              theme="custom"
              color="primary"
              type-bold="true"
              style="top: -17px"
            >
            </switches>
          </b-col>
          <b-col>
            <b-form-group
              label-for="terms-and-conditions"
              :invalid-feedback="displayError('display_instruction_terms')"
              :state="validate('display_instruction_terms')"
            >
              <div slot="label" class="secondary-label">
                Terms &#38; Conditions
              </div>
              <b-form-textarea
                id="terms-and-conditions"
                rows="4"
                v-model="form.display_instruction_terms"
                :maxlength="maxTermsAndConditionsLength"
                placeholder="Enter Details"
                :state="validate('display_instruction_terms')"
                :disabled="!form.show_display_instruction"
              >
              </b-form-textarea>
              <div class="tertiary-label mt-1 ml-auto w-25 text-right">
                ({{ termsAndConditionsCharCount }} /
                {{ maxTermsAndConditionsLength }})
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <hr class="my-5" />
      <template v-if="form.type === 'Free'">
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Reward Label
              <i class="ic-tooltip" id="reward-label-tooltip"></i>
              <b-popover
                target="reward-label-tooltip"
                triggers="hover"
                content="Reward Label"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <b-col md="10">
                <b-form-group
                  label-for="reward-label"
                  :invalid-feedback="displayError('rewards_label')"
                  :state="validate('rewards_label')"
                >
                  <div slot="label" class="secondary-label">Reward Label</div>
                  <b-input
                    id="reward-label"
                    type="text"
                    v-model="form.rewards_label"
                    placeholder="Enter Label"
                    :maxlength="maxRewardLabelLength"
                    :state="validate('rewards_label')"
                  >
                  </b-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="my-5" />
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Inventory
              <i class="ic-tooltip" id="inventory-tooltip"></i>
              <b-popover
                target="inventory-tooltip"
                triggers="hover"
                content="Inventory"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <b-col md="10">
                <b-form-group
                  label-for="inventory"
                  :invalid-feedback="displayError('inventory')"
                  :state="validate('inventory')"
                >
                  <div slot="label" class="secondary-label">Quantity</div>
                  <b-input
                    id="inventory"
                    type="number"
                    class="hide-input-number-spinner"
                    v-model="form.inventory"
                    placeholder="0"
                    :state="validate('inventory')"
                    onpaste="return false;"
                    onkeydown="if(event.key==='.'){event.preventDefault();}"
                    :disabled="form.is_unlimited_inventory || form.is_unlimited_inventory === 1"
                    min="0"
                    oninput="this.value = Math.abs(this.value)"
                  >
                  </b-input>
                  <b-checkbox
                    v-model="form.is_unlimited_inventory"
                    :disabled="form.is_punch_card && form.type == 'Free'"
                    class="mt-3"
                  >
                    <div class="secondary-label">Unlimited</div>
                  </b-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="my-5" />
      </template>
      
      <b-row no-gutters>
        <b-col md="4">
          <div class="primary-label">
            Reward Value
            <i class="ic-tooltip" id="reward-value-tooltip"></i>
            <b-popover
              target="reward-value-tooltip"
              triggers="hover"
              content="Reward Value"
            >
            </b-popover>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col md="10">
              <b-form-group
                label-for="price"
                :invalid-feedback="displayError('price')"
                :state="validate('price')"
              >
                <div slot="label" class="secondary-label">Price</div>
                <b-input-group prepend="Php">
                  <b-input
                    id="price"
                    type="number"
                    class="hide-input-number-spinner"
                    v-model="form.price"
                    placeholder="0.00"
                    :state="validate('price')"
                    min="0"
                    oninput="this.value = Math.abs(this.value)"
                  >
                  </b-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr class="my-5" />
      <template v-if="form.type === 'Points'">
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Points
              <i class="ic-tooltip" id="points-tooltip"></i>
              <b-popover
                target="points-tooltip"
                triggers="hover"
                content="Points"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <b-col md="10">
                <b-form-group
                  label-for="points"
                  :invalid-feedback="displayError('points')"
                  :state="validate('points')"
                >
                  <div slot="label" class="secondary-label">
                    Required Points
                  </div>
                  <b-input-group prepend="Pts">
                    <b-input
                      id="points"
                      type="number"
                      class="hide-input-number-spinner"
                      v-model="form.points"
                      placeholder="0"
                      :state="validate('points')"
                      onpaste="return false;"
                      onkeydown="if(event.key==='.'){event.preventDefault();}"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                    >
                    </b-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="my-5" />
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Inventory
              <i class="ic-tooltip" id="inventory-tooltip"></i>
              <b-popover
                target="inventory-tooltip"
                triggers="hover"
                content="Inventory"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <b-col md="10">
                <b-form-group
                  label-for="inventory"
                  :invalid-feedback="displayError('inventory')"
                  :state="validate('inventory')"
                >
                  <div slot="label" class="secondary-label">Quantity</div>
                  <b-input
                    id="inventory"
                    type="number"
                    class="hide-input-number-spinner"
                    v-model="form.inventory"
                    placeholder="0"
                    :state="validate('inventory')"
                    onpaste="return false;"
                    onkeydown="if(event.key==='.'){event.preventDefault();}"
                    :disabled="form.is_unlimited_inventory || form.is_unlimited_inventory === 1"
                    min="0"
                    oninput="this.value = Math.abs(this.value)"
                  >
                  </b-input>
                  <b-checkbox
                    v-model="form.is_unlimited_inventory"
                    class="mt-3"
                  >
                    <div class="secondary-label">Unlimited</div>
                  </b-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="my-5" />
      </template>
      <b-row no-gutters v-if="form.type === 'Voucher'">
        <b-col md="4">
          <div class="primary-label">
            Reward Duration
            <i class="ic-tooltip" id="reward-duration-tooltip"></i>
            <b-popover
              target="reward-duration-tooltip"
              triggers="hover"
              content="Reward Duration"
            >
            </b-popover>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-radio-group v-model="form.duration_type">
                <b-form-radio
                  v-for="(durationType, index) in voucherDurationTypeOptions"
                  :key="index"
                  :value="durationType.value"
                >
                  {{ durationType.text }}
                  <i
                    class="ic-tooltip"
                    :id="`duration-type-tooltip-${index}`"
                  ></i>
                  <b-popover
                    :target="`duration-type-tooltip-${index}`"
                    triggers="hover"
                    :content="durationType.text"
                  >
                  </b-popover>
                </b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
          <template v-if="form.duration_type === 'Standard'">
            <b-row class="mt-4">
              <b-col>
                <b-form-group
                  :invalid-feedback="displayError('start')"
                  :state="validate('start')"
                >
                  <div slot="label" class="secondary-label">Start Date</div>
                  <b-input-group
                    class="date-picker-wrapper"
                    :class="{ 'invalid-date': displayError('start') }"
                  >
                    <b-input-group-text slot="append">
                      <i class="icon-calendar"></i>
                    </b-input-group-text>
                    <datepicker
                      v-model="form.start"
                      ref="startDatePicker"
                      :config="startDatePickerConfig"
                      :key="startDatePickerKey"
                    >
                    </datepicker>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  :invalid-feedback="displayError('end')"
                  :state="validate('end')"
                >
                  <div slot="label" class="secondary-label">End Date</div>
                  <b-input-group
                    class="date-picker-wrapper"
                    :class="{ 'invalid-date': displayError('end') }"
                  >
                    <b-input-group-text slot="append">
                      <i class="icon-calendar"></i>
                    </b-input-group-text>
                    <datepicker
                      v-model="form.end"
                      ref="endDatePicker"
                      :config="endDatePickerConfig"
                      :key="endDatePickerKey"
                    >
                    </datepicker>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="secondary-label mt-4">Validity</div>
            <b-row class="mt-2">
              <b-col>
                <b-form-group
                  :invalid-feedback="displayError('duration_validity')"
                  :state="validate('duration_validity')"
                >
                  <b-checkbox-group
                    class="duration-validity-days"
                    v-model="form.duration_validity"
                  >
                    <b-form-checkbox
                      v-for="(duration, index) in durationValidityOptions"
                      :key="`repeat_every_${index}`"
                      :value="duration.value"
                      class="px-0"
                      :class="{
                        'border border-danger':
                          displayError('duration_validity'),
                      }"
                    >
                      {{ duration.text }}
                    </b-form-checkbox>
                  </b-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row class="mt-4">
              <b-col md="9">
                <b-form-group
                  label-for="grace-period-start"
                  :state="validate('grace_period_start_of_month')"
                  :invalid-feedback="
                    displayError('grace_period_start_of_month')
                  "
                >
                  <div slot="label" class="secondary-label">
                    Grace Period Prior to the Start of the Month
                  </div>
                  <b-input-group append="Day(s)">
                    <b-input
                      id="grace-period-start"
                      type="number"
                      v-model="form.grace_period_start_of_month"
                      placeholder="0"
                      class="hide-input-number-spinner"
                      :class="[
                        displayError('grace_period_start_of_month')
                          ? 'border-danger'
                          : 'border-right-0',
                      ]"
                    >
                    </b-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9">
                <b-form-group
                  label-for="grace-perio-end"
                  :state="validate('grace_period_end_of_month')"
                  :invalid-feedback="displayError('grace_period_end_of_month')"
                >
                  <div slot="label" class="secondary-label">
                    Grace Period Prior to the End of the Month
                  </div>
                  <b-input-group append="Day(s)">
                    <b-input
                      id="grace-perio-end"
                      type="number"
                      v-model="form.grace_period_end_of_month"
                      placeholder="0"
                      class="hide-input-number-spinner"
                      :class="[
                        displayError('grace_period_end_of_month')
                          ? 'border-danger'
                          : 'border-right-0',
                      ]"
                    >
                    </b-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
      <b-row no-gutters v-if="form.type === 'Free' || form.type === 'Points' || form.type === 'Instant Gratification'">
        <b-col md="4">
          <div class="primary-label mb-2">
            Reward Duration
            <i class="ic-tooltip" id="reward-duration-tooltip"></i>
            <b-popover
              target="reward-duration-tooltip"
              triggers="hover"
              content="Reward Duration"
            >
            </b-popover>
          </div>
          <switches
            v-model="form.on_duration"
            text-enabled="On"
            text-disabled="Off"
            theme="custom"
            color="primary"
            type-bold="true"
            style="top: -17px"
          >
          </switches>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group
                :invalid-feedback="displayError('start')"
                :state="validate('start')"
                :disabled="!form.on_duration"
              >
                <div slot="label" class="secondary-label">Start Date</div>
                <b-input-group
                  class="date-picker-wrapper"
                  :class="{ 'invalid-date': displayError('start') }"
                >
                  <b-input-group-text slot="append">
                    <i class="icon-calendar"></i>
                  </b-input-group-text>
                  <datepicker
                    v-model="form.start"
                    ref="startDatePicker"
                    :config="startDatePickerConfig"
                    :key="startDatePickerKey"
                  >
                  </datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                :invalid-feedback="displayError('end')"
                :state="validate('end')"
                :disabled="!form.on_duration"
              >
                <div slot="label" class="secondary-label">End Date</div>
                <b-input-group
                  class="date-picker-wrapper"
                  :class="{ 'invalid-date': displayError('end') }"
                >
                  <b-input-group-text slot="append">
                    <i class="icon-calendar"></i>
                  </b-input-group-text>
                  <datepicker
                    v-model="form.end"
                    ref="endDatePicker"
                    :config="endDatePickerConfig"
                    :key="endDatePickerKey"
                  >
                  </datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template v-if="form.type === 'Instant Gratification'">
        <hr class="my-5" />
        <template v-if="form.instant_grat_type === 'Rewards'">
          <b-row no-gutters>
            <b-col md="4">
              <div class="primary-label mb-2">
                Assign to Product
                <i class="ic-tooltip" id="assign-product-label-tooltip"></i>
                <b-popover
                  target="assign-product-label-tooltip"
                  triggers="hover"
                  content="Assign to Product"
                >
                </b-popover>
              </div>
              <switches
                v-model="form.assign_to_product"
                text-enabled="On"
                text-disabled="Off"
                theme="custom"
                color="primary"
                type-bold="true"
                style="top: -17px"
                disabled
              >
              </switches>
              <div
                class="badge badge-secondary d-block w-50 py-2"
                style="
                  background-image: linear-gradient(to right, #909190, #c3c1c0);
                "
              >
                Comming Soon
              </div>
            </b-col>
            <b-col>
              <b-form-group
                label-for="assign-to-product"
                :invalid-feedback="displayError('assigned_product')"
                :state="validate('assigned_product')"
              >
                <div slot="label" class="secondary-label">Select Product</div>
                <b-input
                  id="assign-to-product"
                  type="text"
                  v-model="form.name"
                  placeholder="Enter Product SKU"
                  :maxlength="maxRewardNameLength"
                  :state="validate('assigned_product')"
                  disabled
                >
                </b-input>
              </b-form-group>
              <b-btn variant="primary" class="btn-pill px-4" disabled>
                Add
              </b-btn>
              <div class="mt-4 secondary-label">Added Product(s)</div>
            </b-col>
          </b-row>
          <hr class="my-5" />
        </template>
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Upload Codes
              <i class="ic-tooltip" id="upload-codes-label-tooltip"></i>
              <b-popover
                target="upload-codes-label-tooltip"
                triggers="hover"
                content="Upload Codes"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <div class="cursor-pointer">
              <img
                src="@/assets/images/icons/download-blue.svg"
                alt="Download"
              />
              <a
                class="font-weight-bold text-dodger-blue ml-2"
                href="/import/reward_instant_gratification.csv"
              >
                Download Format
              </a>
            </div>
            <b-form-group
              :invalid-feedback="displayError('instant_grat_csv')"
              :state="validate('instant_grat_csv')"
            >
              <b-container
                class="round-dotted-border text-center p-3 mt-3"
                :class="{ 'border-danger': !!displayError('instant_grat_csv') }"
                @dragover.prevent
                @drop.stop.prevent="onInstantGratificationFileInput"
              >
                <img
                  src="@/assets/images/icons/upload-folder-blue.svg"
                  alt="Download"
                  class="mr-2"
                />
                <template>
                  <span>Drop your files here or</span>
                  <span
                    class="text-dodger-blue ml-1 cursor-pointer"
                    @click="$refs.instantGratificationFileInput.click()"
                  >
                    browse
                  </span>
                  <input
                    type="file"
                    ref="instantGratificationFileInput"
                    @change="onInstantGratificationFileInput"
                    accept=".csv"
                    class="d-none"
                  />
                </template>
                <div v-if="form.instant_grat_csv" class="mt-2 font-weight-bold">
                  {{ form.instant_grat_csv.name }}
                </div>
              </b-container>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="my-5" />
        <template v-if="form.instant_grat_type === 'Points'">
          <b-row no-gutters>
            <b-col md="4">
              <div class="primary-label">
                Points
                <i class="ic-tooltip" id="points-label-tooltip"></i>
                <b-popover
                  target="points-label-tooltip"
                  triggers="hover"
                  content="Points"
                >
                </b-popover>
              </div>
            </b-col>
            <b-col>
              <b-row>
                <b-col md="10">
                  <b-form-group
                    label-for="points"
                    :invalid-feedback="displayError('points')"
                    :state="validate('points')"
                  >
                    <div slot="label" class="secondary-label">
                      Points to be given
                    </div>
                    <b-input-group prepend="Pts">
                      <b-input
                        id="points"
                        type="number"
                        class="hide-input-number-spinner"
                        v-model="form.points"
                        placeholder="0"
                        :state="validate('points')"
                        onpaste="return false;"
                        onkeydown="if(event.key==='.'){event.preventDefault();}"
                        :disabled="form.is_points_free || form.is_points_free === 1"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                      >
                      </b-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-row no-gutters>
            <b-col md="4">
              <div class="primary-label">
                Points
                <i class="ic-tooltip" id="points-label-tooltip"></i>
                <b-popover
                  target="points-label-tooltip"
                  triggers="hover"
                  content="Points"
                >
                </b-popover>
              </div>
            </b-col>
            <b-col>
              <b-row>
                <b-col md="10">
                  <b-form-group
                    label-for="points"
                    :invalid-feedback="displayError('points')"
                    :state="validate('points')"
                  >
                    <div slot="label" class="secondary-label">
                      Required Points
                    </div>
                    <b-input-group prepend="Pts">
                      <b-input
                        id="points"
                        type="number"
                        class="hide-input-number-spinner"
                        v-model="form.points"
                        placeholder="0"
                        onpaste="return false;"
                        onkeydown="if(event.key==='.'){event.preventDefault();}"
                        :disabled="form.is_points_free || form.is_points_free === 1"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                      >
                      </b-input>
                    </b-input-group>
                  </b-form-group>
                  <b-form-checkbox v-model="form.is_points_free" :disabled="form.is_punch_card && form.type == 'Instant Gratification'">
                    Free
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </template>
      <hr class="my-5" />
      <b-row no-gutters>
        <b-col md="4">
          <div class="primary-label">
            <div>Redemption</div>
            <div>
              Frequency
              <i class="ic-tooltip" id="redemption-frequency-tooltip"></i>
              <b-popover
                target="redemption-frequency-tooltip"
                triggers="hover"
                content="Redemption Frequency"
              >
              </b-popover>
            </div>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-radio-group
                v-model="form.frequency_type"
                :options="frequencyTypeOptions"
                :disabled="form.is_punch_card"
              >
              </b-form-radio-group>
            </b-col>
          </b-row>
          <b-row v-if="form.frequency_type === 'unlimited'" class="mt-3">
            <b-col md="5">
              <b-form-group label-for="number-of-redemption">
                <div slot="label" class="secondary-label">
                  No. of redemption
                </div>
                <b-form-select
                  id="number-of-redemption"
                  v-model="form.frequency_parameter"
                  :options="numberOfRedemptionOptions"
                  :disabled="form.is_punch_card"
                />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-form-group
                :invalid-feedback="displayError('frequency_value')"
                :state="validate('frequency_value')"
              >
                <b-input
                  type="number"
                  class="hide-input-number-spinner"
                  v-model="form.frequency_value"
                  placeholder="0"
                  :state="validate('frequency_value')"
                  style="margin-top: 28px"
                  onpaste="return false;"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :disabled="form.is_punch_card"
                >
                </b-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else class="mt-3">
            <b-col md="5">
              <b-form-group
                label-for="frequency-value"
                :invalid-feedback="displayError('frequency_value')"
                :state="validate('frequency_value')"
              >
                <div slot="label" class="secondary-label">
                  No. of redemption
                </div>
                <b-input
                  id="frequency-value"
                  type="number"
                  class="hide-input-number-spinner"
                  v-model="form.frequency_value"
                  placeholder="0"
                  :state="validate('frequency_value')"
                  onpaste="return false;"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                >
                </b-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template
        v-if="
          form.type === 'Free' ||
          form.type === 'Points' ||
          form.type === 'Voucher' ||
          (form.type === 'Instant Gratification')
        "
      >
        <hr class="my-5" />
        
        <b-row no-gutters>
          <b-col md="4">
            <div class="primary-label">
              Category
              <i class="ic-tooltip" id="category-tooltip"></i>
              <b-popover
                target="category-tooltip"
                triggers="hover"
                content="Category"
              >
              </b-popover>
            </div>
          </b-col>
          <b-col>
            <b-form-group
              label-for="category"
              :invalid-feedback="displayError('categories')"
              :state="validate('categories')"
            >
              <div slot="label" class="secondary-label">Add Category</div>
              <b-form-textarea
                id="category"
                rows="4"
                v-model="form.categories"
                :state="validate('categories')"
              >
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
    </b-form>
    <div slot="modal-footer" class="w-100 mt-3">
      <b-container fluid>
        <b-row>
          <b-col md="3">
            <b-btn
              variant="ghost"
              class="btn-block btn-cancel"
              @click="$root.$emit('bv::hide::modal', 'new-reward-modal')"
              :disabled="loading"
              block
            >
              Cancel
            </b-btn>
          </b-col>
          <b-col md="3" class="ml-auto text-md-right">
            <b-btn
              variant="primary"
              class="btn-block"
              @click="onCreate"
              :disabled="loading"
              block
            >
              {{ loading ? "Saving..." : "Save" }}
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";
import moment from "moment";
import notification from "@/services/notification";
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

const dateToday = moment().format("YYYY-MM-DD");
const dateTomorrow = moment().add(1, "d").format("YYYY-MM-DD");
const oneActiveItemRequiredError =
  "Cannot proceed with this action. One active item is required.";
const fieldRequiredError = "This field is required.";

export default {
  name: "NewRewardModal",
  data() {
    return {
      startDatePickerKey: null,
      endDatePickerKey: null,
      maxRewardNameLength: 30,
      maxDescriptionLength: 2000,
      maxHowToRedeemLength: 2000,
      maxTermsAndConditionsLength: 2000,
      maxRewardLabelLength: 30,
      rewardTypeOptions: [
        { text: "Free", value: "Free" },
        { text: "Points", value: "Points" },
        { text: "Instant Gratification", value: "Instant Gratification" },
      ],
      voucherTypeOptions: [
        { text: "Item-Based", value: "Item-Based" },
        { text: "Value-Based", value: "Value-Based" },
      ],
      instantGratificationTypeOptions: [
        { text: "Points", value: "Points", disabled: true },
        { text: "Rewards", value: "Rewards" },
      ],
      issueTypeOptions: [
        { text: "Auto Issued", value: "Auto Issued" },
        { text: "Merchant Issued", value: "Merchant Issued" },
      ],
      voucherValueTypeOptions: [
        { text: "Php", value: "Php" },
        { text: "%", value: "%" },
      ],
      voucherDurationTypeOptions: [
        { text: "Standard", value: "Standard" },
        { text: "Birth Month", value: "Birth Month" },
      ],
      frequencyTypeOptions: [
        { text: "Unlimited", value: "unlimited" },
        { text: "Limited", value: "limited" },
      ],
      numberOfRedemptionOptions: [
        { text: "Daily", value: "Daily" },
        { text: "Weekly", value: "Weekly" },
        { text: "Monthly", value: "Monthly" },
      ],
      durationValidityOptions: [
        { value: "Monday", text: "M" },
        { value: "Tuesday", text: "T" },
        { value: "Wednesday", text: "W" },
        { value: "Thursday", text: "T" },
        { value: "Friday", text: "F" },
        { value: "Saturday", text: "S" },
        { value: "Sunday", text: "S" },
      ],
    };
  },
  computed: {
    ...mapState("rewards", ["form", "loading", "errors"]),
    ...mapState("auth", ["enabledTopUps"]),
    ...mapGetters("accountProfile", ["planDetails"]),
    ...mapFields("rewards", ["form"]),
    startDatePickerConfig() {
      const dateEnd = this.form.end;

      return {
        altInput: true,
        altFormat: "m/d/Y",
        dateFormat: "Y-m-d",
        minDate: dateToday,
        maxDate: dateEnd
          ? moment(dateEnd).subtract(1, "d").format("YYYY-MM-DD")
          : null,
      };
    },
    endDatePickerConfig() {
      const dateStart = this.form.start;

      return {
        altInput: true,
        altFormat: "m/d/Y",
        dateFormat: "Y-m-d",
        minDate: dateStart
          ? moment(dateStart).add(1, "d").format("YYYY-MM-DD")
          : dateTomorrow,
      };
    },
    descriptionCharCount() {
      if (!this.form.description) return 0;

      return this.form.description.replace(/<[^>]*>?/gm, "").trim().length;
    },
    howToRedeemCharCount() {
      if (!this.form.redeem_instruction) return 0;

      return this.form.redeem_instruction.replace(/<[^>]*>?/gm, "").trim()
        .length;
    },
    termsAndConditionsCharCount() {
      if (!this.form.display_instruction_terms) return 0;

      return this.form.display_instruction_terms
        .replace(/<[^>]*>?/gm, "")
        .trim().length;
    },
  },
  watch: {
    "form.type"() {
      if (this.errors) this.$store.commit("rewards/errors", null);

      if (this.form.is_punch_card && this.form.type == "Free") {
        this.form.is_unlimited_inventory = true;
        this.form.frequency_parameter = "Daily";
        this.form.frequency_value = 1;
      }

      if (this.form.is_punch_card && this.form.type == "Instant Gratification") {
        this.form.is_unlimited_inventory = true;
        this.form.frequency_parameter = "Daily";
        this.form.frequency_value = 1;

        this.form.points = 0;
        this.form.is_points_free = true;
      }
    },
    "form.bau"() {
      this.validateAvailability();
    },
    "form.privilege_card"() {
      this.validateAvailability();
    },
    "form.membership_tier"() {
      this.validateAvailability();
    },
    "form.survey"() {
      this.validateAvailability();
    },
    "form.is_unlimited_inventory"(isUnlimited) {
      if (isUnlimited) this.form.inventory = 0;
    },
    "form.instant_grat_type"() {
      if (this.errors) this.$store.commit("rewards/errors", null);
    },
    "form.is_points_free"() {
      this.form.points = 0;
    },
    "form.is_punch_card" () {
      if (this.form.is_punch_card) {
        this.form.bau = false;
        this.form.membership_tier = false;
        this.form.privilege_card = false;
        this.form.survey = false;

        this.form.customer_app = false;
        this.form.web = false;
        this.form.gcash = false;
        this.form.punch_card_visible = true;
        this.form.type = "Free";

        this.form.is_unlimited_inventory = true;
        this.form.frequency_parameter = "Daily";
        this.form.frequency_value = 1;

        document.getElementsByClassName("points-type")[0].className = "dropdown-item points-type d-none";
      } else {
        this.form.bau = true;
        this.form.membership_tier = true;
        this.form.privilege_card = ((this.planDetails.enable_privilege_card == 1 && this.enabledTopUps.includes('privilege_card')) ? true : false);
        this.form.survey = true;
        
        this.form.customer_app = true;
        this.form.web = true;
        this.form.gcash = true;
        this.form.punch_card_visible = false;
        document.getElementsByClassName("points-type")[0].className = "dropdown-item points-type"
      }

      this.validateAvailability();
    },
  },
  methods: {
    ...mapActions("rewards", ["create"]),
    initialize() {
      this.startDatePickerKey = `start-${Date.now()}`;
      this.endDatePickerKey = `end-${Date.now()}`;
    },
    validateAvailability() {
      let errors = {};

      if (
        !this.form.bau &&
        !this.form.privilege_card &&
        !this.form.membership_tier &&
        !this.form.survey &&
        !this.form.is_punch_card
      ) {
        if (this.errors === null)
          errors.availability = oneActiveItemRequiredError;
        else
          errors = { ...this.errors, availability: oneActiveItemRequiredError };
      } else delete errors.availability;

      this.$store.commit("rewards/errors", errors);
    },
    toBase64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          return resolve(e.target.result.split(",")[1]);
        };
      });
    },
    async onCreate() {
      const form = { ...this.form };
      const errors = {};

      if (!form.name) errors.name = fieldRequiredError;
      if (!form.image) errors.image = fieldRequiredError;
      if (!form.frequency_value) errors.frequency_value = fieldRequiredError;
      // if (!form.price) errors.price = fieldRequiredError;

      if (form.type === "Free") {
        if (!form.rewards_label) errors.rewards_label = fieldRequiredError;
        if (!form.is_unlimited_inventory && !form.inventory)
          errors.inventory = fieldRequiredError;
        if (form.on_duration) {
          if (!form.start) errors.start = fieldRequiredError;
          if (!form.end) errors.end = fieldRequiredError;
        }
        if (!form.description) errors.description = fieldRequiredError;
        if (form.show_redeem_instruction && !form.redeem_instruction)
          errors.redeem_instruction = fieldRequiredError;
        if (form.show_display_instruction && !form.display_instruction_terms)
          errors.display_instruction_terms = fieldRequiredError;
        if (!form.categories) errors.categories = fieldRequiredError;
      }

      if (form.type === "Points") {
        if (!form.points) errors.points = fieldRequiredError;
        if (!form.is_unlimited_inventory && !form.inventory)
          errors.inventory = fieldRequiredError;
        if (form.on_duration) {
          if (!form.start) errors.start = fieldRequiredError;
          if (!form.end) errors.end = fieldRequiredError;
        }
        if (!form.description) errors.description = fieldRequiredError;
        if (form.show_redeem_instruction && !form.redeem_instruction)
          errors.redeem_instruction = fieldRequiredError;
        if (form.show_display_instruction && !form.display_instruction_terms)
          errors.display_instruction_terms = fieldRequiredError;
        if (!form.categories) errors.categories = fieldRequiredError;
      }

      if (form.type === "Voucher") {
        if (form.voucher_type === "Value-Based" && !form.voucher_discount_value)
          errors.voucher_discount_value = fieldRequiredError;
        if (form.duration_type === "Standard") {
          if (!form.duration_validity.length)
            errors.duration_validity = fieldRequiredError;
          if (!form.start) errors.start = fieldRequiredError;
          if (!form.end) errors.end = fieldRequiredError;
        } else {
          if (!form.grace_period_start_of_month)
            errors.grace_period_start_of_month = fieldRequiredError;
          if (!form.grace_period_end_of_month)
            errors.grace_period_end_of_month = fieldRequiredError;
        }
        if (!form.description) errors.description = fieldRequiredError;
        if (form.show_redeem_instruction && !form.redeem_instruction)
          errors.redeem_instruction = fieldRequiredError;
        if (form.show_display_instruction && !form.display_instruction_terms)
          errors.display_instruction_terms = fieldRequiredError;
        if (!form.categories) errors.categories = fieldRequiredError;
      }

      if (form.type === "Instant Gratification") {
        if (!form.instant_grat_csv)
          errors.instant_grat_csv = fieldRequiredError;
        if (form.on_duration) {
          if (!form.start) errors.start = fieldRequiredError;
          if (!form.end) errors.end = fieldRequiredError;
        }
        if (form.instant_grat_type === "Points") {
          // if (!form.points) errors.points = fieldRequiredError;
        } else {
          if (!form.description) errors.description = fieldRequiredError;
          if (form.show_redeem_instruction && !form.redeem_instruction)
            errors.redeem_instruction = fieldRequiredError;
          if (form.show_display_instruction && !form.display_instruction_terms)
            errors.display_instruction_terms = fieldRequiredError;
          // if (!form.points && !form.is_points_free)
          //   errors.points = fieldRequiredError;
          // if (!form.categories) errors.categories = fieldRequiredError;
        }
      }

      if (
        !form.bau &&
        !form.privilege_card &&
        !form.membership_tier &&
        !form.survey &&
        !form.is_punch_card
      ) {
          errors.availability = oneActiveItemRequiredError;
      }
      
      if (Object.keys(errors).length) {
        this.$store.commit("rewards/errors", errors);
        notification.warning("Oops, Cannot create new reward.");

        return;
      }

      if (form.image) form.image = form.image.split(",")[1];
      if (form.categories) form.categories = form.categories.split(" ");

      if (form.type === "Points" || form.type === "Free") {
        if (form.is_unlimited_inventory) form.inventory = 0;

        form.points = parseInt(form.points);
        form.inventory = parseInt(form.inventory);
      }

      let requestData = null;

      if (form.type === "Free") {
        const {
          points,
          // inventory,
          // is_unlimited_inventory,
          voucher_type,
          voucher_discount_parameter,
          voucher_discount_value,
          duration_type,
          duration_validity,
          grace_period_start_of_month,
          grace_period_end_of_month,
          instant_grat_type,
          issue_type,
          instant_grat_csv,
          ...rest
        } = form;

        requestData = rest;
      }

      if (form.type === "Points") {
        const {
          rewards_label,
          voucher_type,
          voucher_discount_parameter,
          voucher_discount_value,
          duration_type,
          duration_validity,
          grace_period_start_of_month,
          grace_period_end_of_month,
          instant_grat_type,
          issue_type,
          instant_grat_csv,
          ...rest
        } = form;

        requestData = rest;
      }

      if (form.type === "Voucher") {
        const {
          on_duration,
          rewards_label,
          points,
          is_unlimited_inventory,
          inventory,
          instant_grat_type,
          issue_type,
          instant_grat_csv,
          ...rest
        } = form;

        if (rest.duration_type === "Standard") {
          delete rest.grace_period_start_of_month;
          delete rest.grace_period_end_of_month;
        }

        requestData = rest;
      }

      if (form.type === "Instant Gratification") {
        form.instant_grat_csv = await this.toBase64(form.instant_grat_csv);

        if (form.instant_grat_type === "Points") {
          requestData = {
            type: form.type,
            instant_grat_type: form.instant_grat_type,
            issue_type: form.issue_type,
            name: form.name,
            image: form.image,
            instant_grat_csv: form.instant_grat_csv,
            points: form.points,
            frequency_type: form.frequency_type,
            frequency_parameter: form.frequency_parameter,
            frequency_value: form.frequency_value,
            description: form.description,
            show_redeem_instruction: form.show_redeem_instruction,
            redeem_instruction: form.redeem_instruction,
            show_display_instruction: form.show_display_instruction,
            display_instruction_terms: form.display_instruction_terms,
            categories: form.categories,
            on_duration: form.on_duration,
            start: form.start,
            end: form.end,
            bau: form.bau,
            survey:form.survey,
            privilege_card: form.privilege_card,
            membership_tier: form.membership_tier,
            customer_app: form.customer_app,
            web: form.web,
            gcash: form.gcash,
            price: form.price
          };
        } else {
          const {
            rewards_label,
            // start,
            // end,
            // on_duration,
            inventory,
            is_unlimited_inventory,
            voucher_type,
            voucher_discount_parameter,
            voucher_discount_value,
            duration_type,
            duration_validity,
            grace_period_start_of_month,
            grace_period_end_of_month,
            ...rest
          } = form;

          requestData = rest;
        }
      }
      requestData.survey = form.survey
      this.create(requestData).then(() => {
        if (!this.errors)
          this.$root.$emit("bv::hide::modal", "new-reward-modal");
      });
    },
    validate(key) {
      if (this.errors && this.errors.hasOwnProperty(key)) return false;

      return null;
    },
    displayError(key) {
      if (this.errors && this.errors.hasOwnProperty(key))
        return Array.isArray(this.errors[key])
          ? this.errors[key].join(" ")
          : this.errors[key];

      return "";
    },
    onInstantGratificationFileInput(event) {
      let file = null;

      if (event.type === "drop") file = event.dataTransfer.files[0];
      else file = event.target.files[0];

      if (file.name.toLowerCase().includes("csv"))
        this.form.instant_grat_csv = file;

      this.$refs.instantGratificationFileInput.value = null;
    },
    onModalHide() {
      this.$store.commit("rewards/resetForm");
    }
  },
  components: {
    Switches,
    Datepicker,
  },
};
</script>
